import { render, staticRenderFns } from "./SaveButton.vue?vue&type=template&id=4f074d7d&scoped=true&lang=html&"
import script from "./SaveButton.vue?vue&type=script&lang=js&"
export * from "./SaveButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f074d7d",
  null
  
)

export default component.exports